module.exports = __webpack_public_path__ + "img/logo.7201b74f.svg";